"use client";
// pages/404.js

import dynamic from "next/dynamic";
import Link from "next/link";
import React from "react";

const PhysicsText = dynamic(() => import("./PhysicsText"), {
  ssr: false,
});

export default function Custom404() {
  const [showLink, setShowLink] = React.useState(false);

  React.useEffect(() => {
    setTimeout(() => {
      setShowLink(true);
    }, 5000);
  }, []);

  return (
    <div className="bg-[#00a0e9] h-dvh w-screen overflow-hidden flex flex-col font-sans text-white relative">
      <div className="absolute top-8 left-8 z-10">
        <h1 className="text-3xl font-bold">
          TL;DR,
          <br />
          the
          <br /> system <br />
          is
          <br />
        </h1>
      </div>
      <div className="absolute top-8 right-8 z-10">
        <h1 className="text-3xl font-bold">404</h1>
      </div>
      {showLink && (
        <div className="absolute top-[40%] left-[50%]">
          <Link
            href="https://www.superscript.nyc"
            className="text-lg font-bold underline animate-pulse"
          >
            Click me
          </Link>
        </div>
      )}
      <PhysicsText />
    </div>
  );
}
